import { useEffect, useState, useRef } from "react";
import AdminTopNavBar from "../common/AdminTopNavBar";
import getUserMenuItems from "./AdminMenuContent";
import AdminSideBar from "./AdminSideBar";
import { adminReqConfig, api, baseURL } from "../../include/api";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AdminFooter from "../common/AdminFooter";
import { useNotification } from "../../Toast/ToastProvider";
import { ERROR } from "../../include/constant";
import { ChevronDown, X } from "react-feather";
import Papa from "papaparse";
import "../../styles/CategoryProductList.css";
import { formatShortMonthDateYear, getAdmin } from "../../include/function";
import { useSearchParams } from "react-router-dom";

const ReportSales = () => {
  const homeLink = "/admin";
  const [fetchLoading, setFetchLoading] = useState(true);
  const [orderList, setOrderList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isSidebarMinimized, setIsSidebarMinimized] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const toggleSidebar = () => setIsSidebarMinimized(!isSidebarMinimized);
  const menuContent = getUserMenuItems();
  const toast = useNotification();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const initialQuery = searchParams.get("q") || "";
  const [searchQuery, setSearchQuery] = useState(initialQuery);

  useEffect(() => {
    const q = searchParams.get("q") || "";
    setSearchQuery(q);
  }, [searchParams]);
  const [filterValues, setFilterValues] = useState({
    customerName: "",
    OrderFrom: "",
    OrderTo: "",
    orderStatus: "",
  });

  const filterWrapperRef = useRef(null);
  const user = getAdmin();
  const [productPermissions, setProductPermissions] = useState({
    add: false,
    view: false,
    edit: false,
    delete: false,
  });
  useEffect(() => {
    const fetchPermissions = async () => {
      if (!user?.roleId) return;

      try {
        const res = await api.get(
          `/role_permission/?roleId=${user.roleId}`,
          adminReqConfig(),
        );
        if (res.status === 200 && Array.isArray(res.data.data)) {
          // Find permission entry where pageTitle === "Product"
          const productPerm = res.data.data.find(
            (p) => p.pageTitle === "Report Sales",
          );

          if (productPerm) {
            setProductPermissions({
              add: productPerm.add === "true" || productPerm.add === 1,
              view: productPerm.view === "true" || productPerm.view === 1,
              edit: productPerm.edit === "true" || productPerm.edit === 1,
              delete: productPerm.delete === "true" || productPerm.delete === 1,
            });
          }
        }
      } catch (err) {
        console.warn("Failed to fetch product permissions", err);
      }
    };

    fetchPermissions();
  }, [user?.roleId]);
  const fetchOrders = () => {
    setFetchLoading(true);
    api
      .get("/orders/", adminReqConfig())
      .then((res) => {
        const orders = res.data.data || [];

        // Add originalIndex and effectiveStatus
        const normalizedOrders = orders.map((order, index) => ({
          ...order,
          originalIndex: index,
          effectiveStatus:
            (order.status || order.orderItems?.[0]?.status)?.toString() ||
            "unknown",
        }));

        const sortedOrders = normalizedOrders.sort((a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          return dateB - dateA;
        });

        setOrderList(sortedOrders);
        setFilteredData(sortedOrders);
      })
      .catch((error) => {
        toast({ type: ERROR, message: "Error fetching sales data" }, error);
        setOrderList([]);
        setFilteredData([]);
      })
      .finally(() => setFetchLoading(false));
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isFilterPanelOpen &&
        filterWrapperRef.current &&
        !filterWrapperRef.current.contains(event.target)
      ) {
        setIsFilterPanelOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isFilterPanelOpen]);

  const applyFilters = () => {
    setIsFilterPanelOpen(false);
  };

  const clearFilters = () => {
    setFilterValues({
      customerName: "",
      OrderFrom: "",
      OrderTo: "",
      orderStatus: "",
    });
    setIsFilterPanelOpen(false);
  };

  const isDateInRange = (dateStr, from, to) => {
    if (!dateStr) return false;
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return false;
    const fromDate = from ? new Date(from) : null;
    const toDate = to ? new Date(to) : null;
    if (fromDate && isNaN(fromDate.getTime())) return false;
    if (toDate && isNaN(toDate.getTime())) return false;
    return (!fromDate || d >= fromDate) && (!toDate || d <= toDate);
  };

  useEffect(() => {
    let filtered = [...orderList];

    // Filter by customerId
    if (filterValues.customerName) {
      const customerId = parseInt(filterValues.customerName);
      filtered = filtered.filter((order) => order.customerId === customerId);
    }

    // Status filter — use effectiveStatus with trim + lowercase
    if (filterValues.orderStatus) {
      const targetStatus = filterValues.orderStatus.trim().toLowerCase();
      filtered = filtered.filter(
        (order) => order.effectiveStatus.trim().toLowerCase() === targetStatus,
      );
    }

    // Order date filter
    if (filterValues.OrderFrom || filterValues.OrderTo) {
      filtered = filtered.filter((order) =>
        isDateInRange(
          order.createTimestamp,
          filterValues.OrderFrom,
          filterValues.OrderTo,
        ),
      );
    }

    // Search by customer name
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim();
      filtered = filtered.filter((order) =>
        order.name?.toLowerCase().startsWith(query),
      );
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [filterValues, searchQuery, orderList, searchParams]);

  let currentItems = [];
  let totalPage = 1;
  let showingFrom = 0;
  let showingTo = 0;
  if (itemsPerPage === "all") {
    currentItems = filteredData;
    showingFrom = filteredData.length > 0 ? 1 : 0;
    showingTo = filteredData.length;
  } else {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    totalPage = Math.ceil(filteredData.length / itemsPerPage);
    showingFrom = indexOfFirstItem + 1;
    showingTo = Math.min(indexOfLastItem, filteredData.length);
  }
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIndexes = currentItems.map((p) => p.originalIndex);
      setSelectedData((prev) => [...new Set([...prev, ...allIndexes])]);
    } else {
      const indexesToRemove = currentItems.map((p) => p.originalIndex);
      setSelectedData((prev) =>
        prev.filter((idx) => !indexesToRemove.includes(idx)),
      );
    }
  };

  const handleSelectOne = (index) => {
    setSelectedData((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  const handleDownloadCSV = (exportScope = "current") => {
    let dataToExport = [];

    if (selectedData.length > 0) {
      dataToExport = selectedData
        .map((idx) => orderList.find((o) => o.originalIndex === idx))
        .filter(Boolean);
    }
    // ✅ PRIORITY 2: If "Export All" clicked → export entire dataset
    else if (exportScope === "all") {
      dataToExport = orderList;
    }
    // ✅ PRIORITY 3: Default → export current page items only
    else {
      dataToExport = currentItems;
    }

    if (dataToExport.length === 0) {
      toast({ type: "error", message: "No data to download" });
      return;
    }

    // Extract fields excluding "orderItem"
    let allFields = Object.keys(dataToExport[0] || {}).filter(
      (field) => field !== "orderItems",
    );

    // Convert to Capitalized field names
    const formattedFields = allFields.map(
      (f) => f.charAt(0).toUpperCase() + f.slice(1),
    );

    const csvData = dataToExport.map((order) => {
      const row = {};
      allFields.forEach((field) => {
        const formattedKey = field.charAt(0).toUpperCase() + field.slice(1);
        // Fix: Use formatted Customer ID for the 'customerId' field
        if (field === "customerId") {
          row[formattedKey] = formatCustomerId(order);
        } else {
          row[formattedKey] = order[field] !== undefined ? order[field] : "";
        }
      });
      return row;
    });

    // ✅ CRITICAL FIX: Use array of arrays syntax instead of object with "data" key
    const csv = Papa.unparse(
      csvData.map(function (row) {
        return formattedFields.map(function (col) {
          return row[col];
        });
      }),
      {
        header: true,
        columns: formattedFields,
      },
    );

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    // ✅ Dynamic filename based on export type
    const fileName =
      selectedData.length > 0
        ? `Sales_Selected_${selectedData.length}.csv`
        : exportScope === "all"
          ? "Sales_All.csv"
          : `Sales_Page${currentPage}.csv`;

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const generateCustomerPDF = async (order) => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text(`Sales Report`, 14, 20);

    // All fields except "orderItem"
    const allFields = Object.keys(order).filter(
      (field) => field !== "orderItems",
    );

    // Build table data with Capitalized keys
    const tableData = allFields.map((key) => {
      const capKey = key.charAt(0).toUpperCase() + key.slice(1);
      // Fix: Use formatted Customer ID for the 'customerId' field
      const value =
        key === "customerId"
          ? formatCustomerId(order)
          : order[key] !== null && order[key] !== undefined
            ? String(order[key])
            : "";
      return [capKey, value];
    });

    autoTable(doc, {
      startY: 30,
      head: [["Field", "Value"]],
      body: tableData,
      theme: "grid",
      styles: { fontSize: 10, cellPadding: 1.5 },
      headStyles: { fillColor: [43, 149, 211], fontSize: 11 },
      columnStyles: {
        0: { cellWidth: 60, fontStyle: "bold" },
        1: { cellWidth: 120, overflow: "linebreak" },
      },
      margin: { left: 14, right: 14 },
    });

    const timestamp = `Generated on: ${new Date().toLocaleString("en-IN")}`;
    const finalY = doc.previousAutoTable.finalY + 10;

    if (finalY > 270) {
      doc.addPage();
      doc.text(timestamp, 14, 20);
    } else {
      doc.text(timestamp, 14, finalY);
    }

    const safeName = (order.name || "record")
      .replace(/\s+/g, "_")
      .replace(/[^a-zA-Z0-9_-]/g, "");

    doc.save(`Sales_${order.id}_${safeName}.pdf`);
  };

  // Add formatCustomerId function
  const formatCustomerId = (order) => {
    if (!order?.createTimestamp || !order?.customerId) return "CUS--";

    // Extract last 2 digits of year
    const year = new Date(order.createTimestamp).getFullYear();
    const yy = String(year).slice(-2); // e.g., 2025 → "25"

    // Zero-pad customerId to 4 digits
    const paddedId = String(order.customerId).padStart(4, "0"); // e.g., 7 → "0007"

    return `CUS${yy}-${paddedId}`;
  };

  const handleFilterChange = (key, value) => {
    setFilterValues((prev) => ({ ...prev, [key]: value }));
  };

  const PAYMENT_OPTIONS = [
    { value: "paid", label: "Paid" },
    { value: "pending", label: "Pending" },
    { value: "partially-paid", label: "Partially Paid" },
  ];
  const formatOrderId = (order) => {
    if (!order?.createTimestamp || !order?.id) return "ORD--";

    // Extract last 2 digits of year
    const year = new Date(order.createTimestamp).getFullYear();
    const yy = String(year).slice(-2); // e.g., 2025 → "25"

    // Zero-pad order.id to 4 digits
    const paddedId = String(order.id).padStart(4, "0"); // e.g., 7 → "0007"

    return `ORD${yy}-${paddedId}`;
  };
  return (
    <>
      <AdminSideBar
        menuContent={menuContent}
        isMinimized={isSidebarMinimized}
      />
      <AdminTopNavBar
        toggleSidebar={toggleSidebar}
        isSidebarMinimized={isSidebarMinimized}
        homeLink={homeLink}
        title="REPORTS"
      />
      <div
        className="content-wrapper p-0"
        style={{
          marginLeft: isSidebarMinimized ? "80px" : "250px",
          flex: "1",
        }}
      >
        <section
          style={{
            backgroundColor: "#F1F4F9",
            padding: "30px",
            marginTop: "70px",
            marginBottom: "40px",
            minHeight: "80vh",
          }}
        >
          {fetchLoading ? (
            <p>Loading sales data...</p>
          ) : (
            <>
              <div className="rounded-5 bg-white py-24">
                <div className="row align-items-center px-24 py-10 mb-3">
                  <div className="col-auto">
                    <h6 className="mb-0">Sales List</h6>
                  </div>
                  <div className="col d-flex align-items-center">
                    <div
                      className="filter-wrapper"
                      style={{ position: "relative", width: "500px" }}
                      ref={filterWrapperRef}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #c6d6f5",
                          borderRadius: "8px",
                          backgroundColor: "#fff",
                          width: "100%",
                        }}
                      >
                        <img
                          src="/assets/images/search-icon.png"
                          style={{ width: "18px", marginLeft: "8px" }}
                        />
                        <input
                          type="text"
                          placeholder="Filter and Search here..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          onFocus={() => setIsFilterPanelOpen(true)}
                          style={{
                            border: "none",
                            outline: "none",
                            padding: "8px 8px",
                            width: "100%",
                            fontSize: "14px",
                            color: "#333",
                            backgroundColor: "transparent",
                          }}
                        />
                        {searchQuery && (
                          <X
                            size={24}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSearchQuery("");
                              setCurrentPage(1);
                              setIsFilterPanelOpen(false);
                            }}
                            style={{
                              position: "absolute",
                              right: "40px",
                              cursor: "pointer",
                              color: "#999",
                              padding: "4px",
                              zIndex: 10,
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.color = "#666")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.color = "#999")
                            }
                          />
                        )}
                        <ChevronDown
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#999",
                            cursor: "pointer",
                            transform: isFilterPanelOpen
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.2s",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsFilterPanelOpen(!isFilterPanelOpen);
                          }}
                        />
                      </div>

                      {isFilterPanelOpen && (
                        <FilterPanel
                          filterValues={filterValues}
                          onFilterChange={handleFilterChange}
                          onApply={applyFilters}
                          onClear={clearFilters}
                          orderList={orderList}
                          onClick={(e) => e.stopPropagation()}
                        />
                      )}
                    </div>
                  </div>
                  <div className="d-flex col-auto">
                    <div className="">
                      <CustomDropdown handleDownloadCSV={handleDownloadCSV} />
                    </div>
                  </div>
                </div>
                {/* Table */}
                <div className="table-responsive mt-24 product-table">
                  <table className="table table-striped custom-striped-table-product-list align-middle">
                    <thead className="">
                      <tr>
                        <th scope="col" style={{ width: "50px" }}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ borderColor: "#c5d5f5" }}
                            onChange={handleSelectAll}
                            checked={
                              currentItems.length > 0 &&
                              currentItems.every((p) =>
                                selectedData.includes(p.originalIndex),
                              )
                            }
                          />
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Order ID
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Customer
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Order Date
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Amount
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Amount With Tax
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Address
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Payment Status
                        </th>
                        <th
                          scope="col"
                          style={{
                            width: "120px",
                            fontSize: "15px",
                          }}
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((order) => {
                          const fullAddress = [
                            order.address,
                            order.city,
                            order.state,
                          ]
                            .filter(Boolean)
                            .join(", ");
                          return (
                            <tr key={order.originalIndex}>
                              <td>
                                <input
                                  type="checkbox"
                                  style={{ borderColor: "#c5d5f5" }}
                                  className="form-check-input"
                                  checked={selectedData.includes(
                                    order.originalIndex,
                                  )}
                                  onChange={() =>
                                    handleSelectOne(order.originalIndex)
                                  }
                                />
                              </td>
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    textWrap: "nowrap",
                                  }}
                                >
                                  {formatOrderId(order)}
                                </div>
                              </td>
                              <td>{order.name || ""}</td>
                              <td className="text-capitalize">
                                {formatShortMonthDateYear(
                                  order.createTimestamp,
                                ) || ""}
                              </td>
                              <td>&#8377;{order.totalAmount || ""}</td>
                              <td>&#8377;{order.billAmount || ""}</td>
                              <td>{fullAddress}</td>
                              <td>
                                {order.paymentStatus && (
                                  <CustomColoredDropdown
                                    value={order.paymentStatus}
                                    options={PAYMENT_OPTIONS}
                                    type="payment"
                                    disable={true}
                                  />
                                )}
                              </td>
                              <td style={{ position: "relative" }}>
                                <div className="d-flex gap-1">
                                  <button
                                    style={{
                                      backgroundColor: "#D9EBFF",
                                      height: "36px",
                                      width: "70px",
                                      border: "none",
                                      borderRadius: "4px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      padding: "0",
                                      margin: "0",
                                      fontSize: "14px",
                                      lineHeight: 1,
                                      outline: "none",
                                      fontWeight: "600",
                                      color: "#2B95D3",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      generateCustomerPDF(order, baseURL);
                                    }}
                                  >
                                    <img
                                      src="/assets/images/download-icon.png"
                                      alt="download"
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        objectFit: "contain",
                                      }}
                                      onError={(e) =>
                                        (e.target.style.display = "none")
                                      }
                                    />
                                    {`\u00A0\u00A0\u00A0PDF`}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            No sales records found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-16 p-16">
                  <div className="d-flex align-items-center">
                    <select
                      className="form-select d-inline-block w-auto"
                      value={itemsPerPage}
                      onChange={(e) => {
                        const val = e.target.value;
                        setItemsPerPage(val === "all" ? "all" : parseInt(val));
                        setCurrentPage(1);
                      }}
                      style={{
                        height: "34px",
                        fontSize: "14px",
                        minWidth: "70px",
                      }}
                    >
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="all">All</option>
                    </select>
                    <span className="ms-2">
                      Showing {showingFrom} to {showingTo} of{" "}
                      {filteredData.length} records
                    </span>
                  </div>
                  <nav>
                    <ul className="pagination mt-0">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          &laquo;
                        </button>
                      </li>
                      {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(
                          1,
                          currentPage - Math.floor(pagesToShow / 2),
                        );
                        let endPage = startPage + pagesToShow - 1;
                        if (endPage > totalPage) {
                          endPage = totalPage;
                          startPage = Math.max(1, endPage - pagesToShow + 1);
                        }
                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                          pageNumbers.push(i);
                        }
                        return pageNumbers.map((pageNum) => (
                          <li
                            key={pageNum}
                            className={`page-item ${
                              currentPage === pageNum ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => paginate(pageNum)}
                            >
                              {pageNum}
                            </button>
                          </li>
                        ));
                      })()}
                      <li
                        className={`page-item ${
                          currentPage === totalPage ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          &raquo;
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </>
          )}
          <AdminFooter isSidebarMinimized={isSidebarMinimized} />
        </section>
      </div>
    </>
  );
};

export default ReportSales;

const CustomDropdown = ({ handleDownloadCSV }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Options");
  const [isHovered, setIsHovered] = useState(false);
  const dropdownRef = useRef(null);

  const options = [
    { label: "Export", value: "export" },
    { label: "Export All", value: "exportAll" },
  ];

  const handleSelect = (opt) => {
    setSelected(opt.label);
    setIsOpen(false);

    if (opt.value === "export") {
      // ✅ Export = current page only (but selected overrides)
      handleDownloadCSV("current");
    } else if (opt.value === "exportAll") {
      // ✅ Export All = entire dataset (but selected overrides)
      handleDownloadCSV("all");
    }

    setSelected("Options");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div
      className="custom-select"
      style={{ position: "relative", display: "inline-block" }}
      ref={dropdownRef}
    >
      <div
        className="select-header"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          backgroundColor: isHovered ? "#EDF8FA" : "#fff",
          color: "rgba(129, 134, 134, 1)",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          cursor: "pointer",
          width: "140px",
          height: "40px",
          textAlign: "left",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 500,
          transition: "background-color 0.2s ease",
        }}
      >
        <span>{selected}</span>
        <ChevronDown />
      </div>
      {isOpen && (
        <ul
          className="select-options"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            backgroundColor: "white",
            border: "none",
            borderRadius: "4px",
            zIndex: 1000,
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: 500,
          }}
        >
          {options.map((opt) => (
            <li
              key={opt.value}
              onClick={() => handleSelect(opt)}
              className="select-option"
              style={{
                padding: "8px 12px",
                color: "rgba(129, 134, 134, 1)",
                backgroundColor: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const FilterPanel = ({
  filterValues,
  onFilterChange,
  onApply,
  onClear,
  orderList,
  onClick,
}) => {
  //Dropdown options
  const PAYMENT_OPTIONS = [
    { value: "paid", label: "Paid" },
    { value: "pending", label: "Unpaid" },
    { value: "partially paid", label: "Partially Paid" },
  ];

  const APPROVAL_OPTIONS = [
    { value: "approved", label: "Approved" },
    { value: "rejected", label: "Rejected" },
  ];

  const STATUS_OPTIONS = [
    { value: "ordered", label: "Recieved" },
    { value: "confirmed", label: "Confirmed" },
    { value: "packed", label: "Packed" },
    { value: "shipped", label: "Shipped" },
    { value: "delivered", label: "Delivered" },
    { value: "return", label: "Return" },
    { value: "cancelled", label: "Cancelled" },
  ];

  const uniqueCustomers = Array.from(
    new Map(orderList.map((order) => [order.customerId, order])).values(),
  );

  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "500px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        zIndex: 1000,
        padding: "16px",
        maxHeight: "600px",
        overflowY: "auto",
        marginTop: "10px",
      }}
      onClick={onClick}
    >
      <div className="row g-3">
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.customerName}
            onChange={(e) => onFilterChange("customerName", e.target.value)}
          >
            <option value="">Customer Name</option>
            {uniqueCustomers.map((customer) => (
              <option key={customer.customerId} value={customer.customerId}>
                {customer.name}
              </option>
            ))}
          </select>
        </div>

        <h6 className="fs-6 mb-0 mt-3">Order Status</h6>
        <div className="col-md-12">
          <select
            className="form-select filter-input"
            value={filterValues.orderStatus}
            onChange={(e) => onFilterChange("orderStatus", e.target.value)}
          >
            <option value="">All Status</option>
            {STATUS_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <h6 className="fs-6 mb-0">Based on Order Date</h6>
        <div className="col-md-6">
          <input
            type="date"
            className="form-control filter-input"
            value={filterValues.OrderFrom}
            onChange={(e) => onFilterChange("OrderFrom", e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <input
            type="date"
            className="form-control filter-input"
            value={filterValues.OrderTo}
            onChange={(e) => onFilterChange("OrderTo", e.target.value)}
          />
        </div>
      </div>
      <div className="d-flex gap-14 mt-24">
        <button
          onClick={onApply}
          style={{
            color: "#fff",
            backgroundColor: "#2b95d3",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
          }}
        >
          Apply Filters
        </button>
        <button
          onClick={onClear}
          style={{
            color: "#2692d2",
            backgroundColor: "#d9ebff",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
            gap: "6px",
          }}
        >
          Clear All
        </button>
      </div>
    </div>
  );
};

const CustomColoredDropdown = ({
  value,
  onChange,
  options,
  type = "payment",
  disable = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const getColors = (status) => {
    if (type === "approval") {
      switch (status) {
        case "approved":
          return {
            color: "#065F46",
            bg: "#D1FAE5",
            border: `1px solid #065F46`,
          };
        case "rejected":
          return {
            color: "#991B1B",
            bg: "#FEE2E2",
            border: `1px solid #991B1B`,
          };
        default:
          return { color: "#CF9500", bg: "#FFF3BA", border: "none" };
      }
    }
    if (type === "payment") {
      switch (status) {
        case "paid":
          return { color: "white", bg: "#26DD8E", border: `1px solid #26DD8E` };
        case "pending":
          return { color: "white", bg: "#F8556D", border: `1px solid #F8556D` };
        case "partially-paid":
          return {
            color: "white",
            bg: "#D19A04",
            border: `1px solid #D19A04`,
          };
        default:
          return { color: "black", bg: "#fff", border: `1px solid #ccc` };
      }
    } else {
      switch (status) {
        case "delivered":
          return { color: "#46A27B", bg: "#D5F5E7", border: "none" };
        case "shipped":
          return { color: "#CF9500", bg: "#FFF3BA", border: "none" };
        case "packed":
          return { color: "#AC29AC", bg: "#FFCEFF", border: "none" };
        case "ordered":
          return { color: "#66B2E2", bg: "#D9EBFF", border: "none" };
        case "cancelled":
          return { color: "#E54611", bg: "#FDDFD0", border: "none" };
        case "return":
          return { color: "#8977C3", bg: "#DDD5F5", border: "none" };
        case "confirmed":
          return { color: "#39AFA7", bg: "#BFEFEC", border: "none" };
        case "rejected":
          return { color: "#E54611", bg: "#FDDFD0", border: "none" };
        default:
          return { color: "black", bg: "#f5f5f5", border: "none" };
      }
    }
  };
  const { color, bg, border } = getColors(value);
  const displayLabel =
    options.find((opt) => opt.value === value)?.label ||
    (value
      ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
      : value);

  // Only allow interaction if NOT disabled
  const handleToggle = () => {
    if (!disable) {
      setIsOpen(!isOpen);
    }
  };

  const handleOptionClick = (val) => {
    if (!disable) {
      onChange?.(val);
      setIsOpen(false);
    }
  };

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        fontSize: "14px",
      }}
    >
      {/* Main Button */}
      <div
        onClick={handleToggle}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "6px 12px",
          border: border,
          borderRadius: "6px",
          backgroundColor: bg,
          cursor: disable ? "default" : "pointer", // 👈 visual cue
          fontWeight: "500",
          color: color,
          minWidth: "120px",
          opacity: disable ? 0.7 : 1, // optional: gray out when disabled
          pointerEvents: disable ? "none" : "auto", // 🔒 blocks all clicks if disabled
        }}
      >
        <span>{displayLabel}</span>
        {!disable && (
          <ChevronDown size={14} style={{ color, marginLeft: "6px" }} />
        )}
      </div>

      {/* Dropdown Menu — only show if enabled and open */}
      {!disable && isOpen && (
        <>
          <ul
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              width: "100%",
              listStyle: "none",
              margin: 0,
              padding: 0,
              backgroundColor: "#fff",
              border: border === "none" ? "none" : border,
              borderRadius: "6px",
              zIndex: 1000,
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              maxHeight: "150px",
              overflowY: "auto",
            }}
          >
            {options.map((opt) => {
              const optColors = getColors(opt.value);
              return (
                <li
                  key={opt.value}
                  onClick={() => handleOptionClick(opt.value)}
                  style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    color: optColors.color,
                    backgroundColor: optColors.bg,
                    fontWeight: "500",
                    border: "none",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#f0f0f0")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = optColors.bg)
                  }
                >
                  {opt.label}
                </li>
              );
            })}
          </ul>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 999,
            }}
            onClick={() => setIsOpen(false)}
          />
        </>
      )}
    </div>
  );
};
